import React from 'react';
import { Tab, Segment } from 'semantic-ui-react';
import { withNamespaces } from 'react-i18next';
import PayPal from './PayPal';
import PurchaseOrder from './PurchaseOrder';
import ZeroPayment from './Zero';


const PaymentTab = (props) => {
  const {
    t,
    data,
    payPalClient,
    payPalEnv,
    onPaypalSuccess,
    onPaypalError,
    onPurchaseOrderSuccess,
    onZeroPaymentSuccess
  } = props;

  const total = data.reduce((acc, val) => acc += val.total, 0);

  const panes = [
    {
      menuItem: t('private:payment.type.paypal'),
      render: () =>
        <Tab.Pane>
          <Segment>
            {t('private:paypal.intro')}
          </Segment>
          <PayPal
            data={data}
            client={payPalClient}
            onSuccess={onPaypalSuccess}
            onError={onPaypalError}
            env={payPalEnv} />
        </Tab.Pane>
    },
    {
      menuItem: t('private:payment.type.invoice'),
      render: () =>
        <Tab.Pane>
          <PurchaseOrder
            data={data}
            onSubmit={onPurchaseOrderSuccess}/>
        </Tab.Pane>
    }
  ];

  const panesZero = [
    {
      menuItem: t('private:payment.type.zero'),
      render: () =>
        <Tab.Pane>
          <ZeroPayment
            data={data}
            onSubmit={onZeroPaymentSuccess}/>
        </Tab.Pane>
    }
  ];

  return  <Tab
            panes={total ? panes : panesZero}
            renderActiveOnly={true} />;
};

export default withNamespaces(['private'])(PaymentTab);



// WEBPACK FOOTER //
// ./src/private/user/components/Payment/Tab.js